module.exports = __webpack_public_path__ + "img/Customer_Empathy.1faaceab.jpg";